module.exports = __webpack_public_path__ + "static/media/marker_temporary_bus_stop_green.b0e10d6a.svg";